import {
  failed,
  loading,
  offersLoaded,
  filterSet,
  filterResultSet,
  offerSelected,
  lazyLoading,
  lazyLoaded,
  flightReset,
} from "./flightSlice";
import Axios from "axios";
import { searchFlightsUrl } from "./apis";
import { ofcAppend, setProgress } from "../actions";
import { calCulateOverallprice } from "../../util/Helpers2";

const track = (data: any, dict: any, getState: any) => {
  let x = {
    airlineName:
      dict["airline"][data["itineraries"][0]["segments"][0].carrierCode].name,
    airlineCode: data["itineraries"][0]["segments"][0].carrierCode,
    airlineLogo:
      dict["airline"][data["itineraries"][0]["segments"][0].carrierCode].logo,
    currency: getState().app.currency.code,
    departCity:
      dict["airport"][data["itineraries"][0]["segments"][0].departurecode]
        .region,
    userCountry: getState().app.info.country_name,
    departCode: data["itineraries"][0]["segments"][0].departurecode,
    arriveCode:
      data["itineraries"][0]["segments"][
        data["itineraries"][0]["segments"]?.length - 1
      ].arrivalCode,
    arriveCity:
      dict["airport"][
        data["itineraries"][0]["segments"][
          data["itineraries"][0]["segments"]?.length - 1
        ].arrivalCode
      ].region,
    userCity: getState().app.info.city_name,
    price: calCulateOverallprice(data.travelers),
  };
  console.log(x);
  ofcAppend(x);
};
export const searchFlightOffersPriority =
  (data: any, func: any, errFunc: any) =>
  async (dispatch: any, getState: any) => {
    dispatch(loading());
    dispatch(setProgress(0));
    Axios.post(searchFlightsUrl, data, {
      onUploadProgress: (progressEvent: any) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );

        dispatch(setProgress(percentCompleted));
      },
    })
      .then((res) => {
        console.log("sad");
        dispatch(offersLoaded(res.data));
        track(res.data.offers[0], res.data.dictionary, getState);
        func();
      })

      .catch((err) => {
        console.log(err);
        dispatch(failed(err.response));
        errFunc();
      });
  };
export const setFilter = (key: any, unit: any) => (dispatch: any) => {
  dispatch(filterSet({ key, unit }));
};

export const processFilter = () => (dispatch: any) => {
  dispatch(filterResultSet());
};
export const setOffer = (payload: any) => (dispatch: any) => {
  dispatch(offerSelected(payload));
};
export const resetFlight = () => (dispatch: any) => {
  dispatch(flightReset());
};
export const delayFlightLoad = () => (dispatch: any) => {
  dispatch(lazyLoading());
  setTimeout(() => {
    dispatch(lazyLoaded());
  }, 1500);
};
